// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ContactAgentButton = require("../../common/Agent/ContactAgentButton.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyPage__NextShowing = require("../../propertyPage/PropertyPage__NextShowing.bs.js");
var PropertyWizardRelay__Preview__Shared = require("./PropertyWizardRelay__Preview__Shared.bs.js");
var PropertyPage__RentalPropertySidecard__MlsInfo = require("../../propertyPage/PropertyPage__RentalPropertySidecard__MlsInfo.bs.js");
var PropertyPage__ForSalePropertySidecard__MlsInfo = require("../../propertyPage/PropertyPage__ForSalePropertySidecard__MlsInfo.bs.js");
var PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
var PropertyWizardRelayPreviewSidecard_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_formState_graphql.bs.js");
var PropertyWizardRelayPreviewSidecard_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_localDraft_graphql.bs.js");
var PropertyWizardRelayPreviewSidecard_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.bs.js");

var convertFragment = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

var DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertFragment$2 = PropertyWizardRelayPreviewSidecard_formState_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

var FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__Preview__Sidecard(props) {
  var draft = use(props.draft);
  var formState = use$2(props.formState);
  var displayHelpers = use$1(props.displayHelpers);
  var onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var mlsPreviewErrorMessages = PropertyWizardRelay__Preview__Shared.getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, props.onEditForm);
  var match = draft.draftProperty.propertyType;
  var tmp;
  tmp = match === "FOR_SALE" ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(PropertyPage__NextShowing.make, {
                showings: Core__Option.getOr(displayHelpers.showings, []).map(function (x) {
                      return x.fragmentRefs;
                    }),
                timezone: DateFnsTz.Timezone.make(draft.timeZone)
              }),
          className: "pb-4 border-b-gray-200 border-b"
        }) : null;
  var tmp$1;
  if (mlsPreviewErrorMessages !== undefined) {
    tmp$1 = JsxRuntime.jsx("div", {
          children: Caml_option.valFromOption(mlsPreviewErrorMessages),
          className: "pb-4 border-b-gray-200 border-b"
        });
  } else {
    var match$1 = displayHelpers.mlsPlan;
    var match$2 = draft.draftProperty.propertyType;
    if (match$1 !== undefined) {
      var fragmentRefs = match$1.fragmentRefs;
      tmp$1 = match$2 === "FOR_SALE" ? JsxRuntime.jsx(PropertyPage__ForSalePropertySidecard__MlsInfo.FromMlsPlan.make, {
              mlsPlan: fragmentRefs,
              className: "pb-4 border-b-gray-200 border-b"
            }) : JsxRuntime.jsx(PropertyPage__RentalPropertySidecard__MlsInfo.FromMlsPlan.make, {
              mlsPlan: fragmentRefs,
              className: "pb-4 border-b-gray-200 border-b"
            });
    } else {
      tmp$1 = null;
    }
  }
  var match$3 = displayHelpers.agent;
  var agent = displayHelpers.agent;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        tmp,
                        tmp$1,
                        match$3 !== undefined ? JsxRuntime.jsx(AgentInfo.make, {
                                agent: match$3.fragmentRefs,
                                size: "medium"
                              }) : null
                      ],
                      className: "px-4 flex flex-col gap-4 py-4"
                    }),
                JsxRuntime.jsx("div", {
                      children: agent !== undefined ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(ContactAgentButton.make, {
                                      agent: agent.fragmentRefs,
                                      fullWidth: true,
                                      variant: "Secondary",
                                      children: Caml_option.some(JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Icon__Jsx3.make, {
                                                        icon: "Comment"
                                                      }),
                                                  "Contact agent"
                                                ],
                                                className: "flex items-center gap-2"
                                              }))
                                    }),
                                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                      disabled: true,
                                      size: "small",
                                      icon: "Share",
                                      children: "Share with client"
                                    })
                              ],
                              className: "my-6 px-4 grid grid-cols-1 xl:grid-cols-2 gap-2"
                            }) : null,
                      className: "bg-gray-100 border-t border-gray-200 rounded-b-md"
                    })
              ],
              className: "border border-gray-200 rounded-md bg-white flex flex-col sticky top-16 max-w-sm"
            });
}

var MissingFieldMarker;

var Validators;

var Shared;

var ForSaleMlsInfo;

var RentalMlsInfo;

var make = PropertyWizardRelay__Preview__Sidecard;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.Shared = Shared;
exports.DraftFragment = DraftFragment;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.FormStateFragment = FormStateFragment;
exports.ForSaleMlsInfo = ForSaleMlsInfo;
exports.RentalMlsInfo = RentalMlsInfo;
exports.make = make;
/* AgentInfo Not a pure module */
